import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import store from '@/store'
/**
 * 单点登录
 */

const init = (callback) => {
  console.log("-------单点登录开始-------");
  let token = Vue.ls.get(ACCESS_TOKEN);
  let st = getUrlParam('ticket');
  var sevice = process.env.NODE_ENV === 'production' ? 
  'https://jpgl.canc.com.cn/knowledge/file/BusKnowledgeFileList' : 'https://jptest.canc.com.cn/jpglManagerTest/knowledge/file/BusKnowledgeFileList';
  // var sevice = 'http://192.168.60.82/knowledge/file/BusKnowledgeFileList';
  // alert(sevice)
  // alert(st)
  if(token){
    loginSuccess(callback);
  }else{
    setTimeout(() => {
      if(st){
        validateSt(st,sevice,callback);
      }else{
        var serviceUrl = encodeURIComponent(sevice);
        window.location.href = window._CONFIG['casPrefixUrl']+"/login?service="+serviceUrl;
      }
    },500)
  }
  console.log("-------单点登录结束-------");
};
const SSO = {
  init: init
};

function getUrlParam(paraName) {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arr;
    arr = arrObj[1].split("=");
    // alert(arr[1])
    return arr[1];
  }
  else {
    return "";
  }
}

function validateSt(ticket,service,callback){
  let params = {
    ticket: ticket,
    service:service
  };
  store.dispatch('ValidateLogin',params).then(res => {
    // alert(JSON.stringify(res))
    if(res.success){
      loginSuccess(callback);
    }else{
      var sevice = "http://"+window.location.host+"/";
      var serviceUrl = encodeURIComponent(sevice);
      window.location.href = window._CONFIG['casPrefixUrl']+"/login?service="+serviceUrl;
    }
  }).catch((err) => {
    console.log(err);
    //that.requestFailed(err);
  });
}

function loginSuccess (callback) {
  location.reload()
  callback();
}
export default SSO;